import $ from 'jquery';
import _ from 'lodash';
import { fetchCards } from '~loader/loader-api';
import { setServizio } from './setServizio';
import { getState, modifyState } from '~src/state';
import formatDistance from 'date-fns/formatDistance';
import it from 'date-fns/locale/it';
import { getStatePure } from '../../state';

// Lightweight GDS-based table (no DataTables dependency)
export const initDatatableServizi = async () => {
  if (window.editorLoader.datatableServiziInitialised) return;

  const cards = await fetchCards();
  const sortedCards = _.orderBy(cards, 'createdAt', 'desc');

  $('#editorSpinnerServizio').remove();

  const $modalBody = $('#modalEditorServizio .modal-body');
  const $table = $('#editorChooseCard');

  // Wrap and apply GDS styles (no card wrapper)
  $table.addClass('g-table g-table--clickable g-table--zebra');
  if (!$table.parent().hasClass('g-table-wrapper')) {
    $table.wrap('<div class="g-table-wrapper"></div>');
  }
  const $wrapper = $table.parent('.g-table-wrapper');

  // Inject controls (page size + search with icon)
  const $controls = $(`
    <div class="g-table-controls">
      <div class="g-table-control">
        <label for="gdsTablePageSize" style="margin:0; font-size: 13px; color: #64748b;">Righe per pagina</label>
        <select id="gdsTablePageSize" class="g-select">
          <option value="5">5</option>
          <option value="10">10</option>
          <option value="50">50</option>
          <option value="-1">Tutti</option>
        </select>
      </div>
      <div class="g-table-control" style="margin-left:auto;">
        <div class="g-input-icon">
          <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7" stroke-width="2" fill="none"></circle><line x1="16.5" y1="16.5" x2="21" y2="21" stroke-width="2"></line></svg>
          <input id="gdsTableSearch" class="g-input" type="search" placeholder="Cerca una card" />
        </div>
      </div>
    </div>
  `);

  $wrapper.prepend($controls);

  // Build table header
  const theadHtml = `
    <thead>
      <tr>
        <th>Nome</th>
        <th>Cognome</th>
        <th>Impresa</th>
        <th>Creata</th>
      </tr>
    </thead>
    <tbody></tbody>
  `;
  $table.html(theadHtml);

  // Pagination container
  const $pagination = $(`
    <div class="g-pagination">
      <button id="gdsPrevPage" class="g-btn g-btn-outline g-btn-size-sm g-text-black">Precedente</button>
      <button id="gdsNextPage" class="g-btn g-btn-outline g-btn-size-sm g-text-black">Prossima</button>
      <span id="gdsPageInfo" class="g-page-info"></span>
    </div>
  `);
  $wrapper.append($pagination);

  // Local state
  const state = {
    page: 1,
    pageSize: 5,
    search: '',
  };

  const normalise = (s) => (s || '').toString().toLowerCase();

  const filterCards = () => {
    const q = normalise(state.search);
    if (!q) return sortedCards;
    return sortedCards.filter((c) => {
      const parts = [c.firstName, c.lastName, c.companyName];
      return parts.some((p) => normalise(p).includes(q));
    });
  };

  const render = () => {
    const data = filterCards();
    const total = data.length;
    const pageSize = state.pageSize === -1 ? total || 1 : state.pageSize;
    const maxPage = Math.max(1, Math.ceil(total / pageSize));
    state.page = Math.min(state.page, maxPage);
    const startIndex = (state.page - 1) * pageSize;
    const endIndex = Math.min(total, startIndex + pageSize);

    const pageRows = data.slice(startIndex, endIndex);

    const rowsHtml = pageRows
      .map((row) => {
        const created = formatDistance(new Date(row.createdAt), new Date(), {
          addSuffix: false,
          locale: it,
        });
        return `
          <tr data-id="${row.id}">
            <td>${row.firstName || ''}</td>
            <td>${row.lastName || ''}</td>
            <td>${row.companyName || ''}</td>
            <td>${created}</td>
          </tr>
        `;
      })
      .join('');

    const $tbody = $table.find('tbody');
    if (rowsHtml) {
      $tbody.html(rowsHtml);
    } else {
      $tbody.html(
        '<tr><td colspan="4"><div class="g-table-empty">Non ci sono elementi da mostrare</div></td></tr>'
      );
    }

    // Update pagination UI
    $('#gdsPrevPage').prop('disabled', state.page <= 1);
    $('#gdsNextPage').prop('disabled', state.page >= maxPage);
    const startDisp = total === 0 ? 0 : startIndex + 1;
    $('#gdsPageInfo').text(
      `Mostro da ${startDisp} a ${endIndex} di ${total} valori`
    );
  };

  // Event listeners
  $modalBody.on('input', '#gdsTableSearch', (e) => {
    state.search = e.target.value || '';
    state.page = 1;
    render();
  });

  $modalBody.on('change', '#gdsTablePageSize', (e) => {
    state.pageSize = parseInt(e.target.value, 10);
    state.page = 1;
    render();
  });

  $modalBody.on('click', '#gdsPrevPage', () => {
    state.page = Math.max(1, state.page - 1);
    render();
  });

  $modalBody.on('click', '#gdsNextPage', () => {
    state.page = state.page + 1;
    render();
  });

  // Row click handler
  $table.on('click', 'tbody tr', function () {
    const id = $(this).data('id');
    const selectedCard = getStatePure('cards').find((card) => card.id === id);
    if (!selectedCard) return;

    setServizio(selectedCard, true);

    const cardsState = getState('cards', []);
    const cardBySlug = cardsState.find((c) => c.slug === selectedCard.slug);
    if (cardBySlug) modifyState('card', cardBySlug);

    setTimeout(() => {
      $('#modalEditorServizio').modal('hide');
      $('.modal-backdrop').remove();
    }, 200);
  });

  // Initial render
  render();

  window.editorLoader.datatableServiziInitialised = true;
};
